/* istanbul ignore file */

export enum GridFilterTypes {
    Text = 'text',
    Date = 'date',
    Boolean = 'boolean',
    Numeric = 'numeric'
}
